<ion-item>
  <ion-grid>
    <ion-row (click)="toggleExpand()">
      <ion-col size="6"
               class="ion-text-start"
               [class.bold]="isFilterActive">
        {{ filterNameKey | translate }}
      </ion-col>
      <ion-col size="5"
               class="ion-text-end">
        @if (clearable && (dateFrom || dateTo)) {
          <span class="font-color-light"
                (click)="clearFilter($event)">
            {{ 'reports.clear' | translate }}
          </span>
        }
      </ion-col>
      <ion-col size="1"
               class="ion-text-end">
        <ion-icon src="assets/icon/icon-expand-arrow.svg"
                  [class.vertical-flip]="isExpanded" />
      </ion-col>
    </ion-row>
    @if (isExpanded) {
      <div>
        <ion-row>
          <ion-col size="6">
            <app-date-input placeholder="rollover.from"
                            [minDate]="minDateFrom"
                            [maxDate]="maxDateFrom"
                            [date]="dateFrom"
                            (changeDate)="onDateFromChanged($event)" />
          </ion-col>
          <ion-col size="6">
            <app-date-input placeholder="rollover.to"
                            [minDate]="minDateTo"
                            [maxDate]="maxDateTo"
                            [date]="dateTo"
                            (changeDate)="onDateToChanged($event)" />
          </ion-col>
        </ion-row>
      </div>
    }
  </ion-grid>
</ion-item>